import { useMutation } from "@tanstack/react-query";
import { apiV1Endpoint } from "../../../../../../../api/v1";
import { ApiResponse } from "../../../../../../../types/api-response";
import { Booking } from "../../../../../../../types/bookings";
import axios from "../../../../../../../utils/axiosInceptor";
import { BillingScheduleBreakdown, CommercialPaymentPlan } from "./types";

export type SaveBillingScheduleRequest = {
  leaseId: string;
  commercialPaymentPlan: CommercialPaymentPlan[];
  commercialBillingScheduleBreakdown: BillingScheduleBreakdown[];
  bookingTerms?: Booking["bookingTerms"];
  depositPayments?: Booking["depositPayments"];
};

const saveBillingSchedule = async (payload: SaveBillingScheduleRequest) => {
  const url = `${apiV1Endpoint}/booking/updateMonthlyBillingSchedule`;
  const response = await axios.post<ApiResponse<void>>(url, payload);
  return response.data;
};

type UseSaveBillingScheduleOptions = {
  onSuccess?: () => void;
  onError?: (error: unknown) => void;
};

export const useSaveBillingSchedule = (options: UseSaveBillingScheduleOptions = {}) => {
  const { onSuccess, onError } = options;

  const { mutateAsync, isPending } = useMutation({
    mutationFn: saveBillingSchedule,
    onSuccess,
    onError,
  });

  return {
    saveBillingSchedule: mutateAsync,
    isPendingSaveBillingSchedule: isPending,
  };
};
